import { Button, Row, Col } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import classify from "../../../../assets/images/Logo-classify.png";
import iconSvg from "../../../../assets/images/icon/check.svg";
import iconNext from "../../../../assets/images/icon/next-arrow.svg";
import "../../../../i18n/i18n";
import { i18n } from '../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";
import queryString from "query-string";
const DaolSecClassifyPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolSecClassify);
  // const paramFrom = localStorage.getItem("param_from");
  // const paramReques = localStorage.getItem("param_reques");
  const { search } = useLocation();
  const query: any = queryString.parse(search);
  const param_customer = localStorage.getItem("param_customer");
  if (
    query?.from !== undefined || query?.reques !== undefined || query?.customerid !== undefined
  ) {
    localStorage.setItem("param_from", query?.from);
    localStorage.setItem("param_reques", query?.reques);
    localStorage.setItem("param_customer", query?.customerid);
    localStorage.setItem("param_formid", query?.workingid);
  }
  useEffect(() => {
    window.document.title = "DAOL - Classify";
  }, []);
  const onClickNext = () => {
    console.log('param_customer', param_customer);
    history.push({
      pathname: "/contents/daolSec/classify/loginDate",
      state: {
        customerId: param_customer
      },
    });
  }

  return (
    <>
      <Row className="container-main daol-kyc">
        {console.log('useTranslation(namespaces.pages.daolSecKyc)', i18n.language)}
        {console.log('param_customerparam_customerparam_customer', param_customer)}
        <div className="content-right col-sm-10 text-center">
          <p className="text-header"><b>{t("title")}</b></p>
          <p>{t("text_descrip")}</p>
          <p><img src={classify} alt="Logo-classify" width="80%" /></p>
          <p className="sub-text-header">{t("descrip_p1")}</p>

          <div className="text-left descrip-content">
            {(param_customer === "undefined" || param_customer === "") ? (
              <>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p2")}</p>   
                <p><img src={iconSvg} alt="icon" />{t("descrip_p6")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p3")}</p>
             
                <span><img src={iconSvg} alt="icon" /></span>
                <span>{t("descrip_p4")}</span>
                <p className="remark-classify-sec">{t("descrip_p4_remark")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p5")}</p>
              </>
            ) : (
              <>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p1_eng")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p5")}</p>
              </>
            )}

          </div>
          {/* {console.log('localStorage.getItem("param_customer")', param_customer !== 'undefined')} */}
          <div className="container-button btn-kyc">
            {(param_customer === "undefined" || param_customer === "") ?
              (<span className="remark">{t("descrip_remark")}</span>) : ""}

            {param_customer === 'undefined' ? (<Button
              type="primary"
              className="btn-next"
              onClick={() => history.push(`/contents/daolSec/classify/loginClassify`)}
            >
              {t("btn_next")}
              <img src={iconNext} alt="icon-next" />
            </Button>) :
              (<Button
                type="primary"
                className="btn-next"
                onClick={onClickNext}
              >
                {t("btn_next")}
                <img src={iconNext} alt="icon-next" />
              </Button>)}
          </div>
        </div>
      </Row>

    </>
  );
};
export default DaolSecClassifyPage;
